import React from "react";

export default function FooterCard15() {
  return (<>
    <footer className="gaming-footer">

      {/* Top Section */}
      <div className="gf-top">
        <div className="gf-col">
          <h3>MAIL & PHONE</h3>
          <p>gaminginformation@gmail.com</p>
          <p>+123456789</p>
        </div>

        <div className="gf-logo-col">
          <div className="gf-logo">Explore Courses</div>
        </div>

        <div className="gf-col">
          <h3>ADDRESS</h3>
          <p>1122 Potter Rd, Antelope, CA</p>
          <p>32802</p>
        </div>
      </div>

      {/* Divider */}
      <div className="gf-divider"></div>

      {/* Middle Section */}
      <div className="gf-mid">

        {/* Quick Links */}
        <div className="gf-col">
          <h3>Quick Links</h3>
          <ul>
            <li>Home</li>
            <li>Blog</li>
            <li>Page</li>
            <li>Contact</li>
          </ul>
        </div>

        {/* Recent Posts */}
        <div className="gf-col">
          <h3>Top Courses</h3>
          <div className="gf-post">
            <div className="gf-thumb"></div>
            <div>
              <p className="gf-post-title">Course title3</p>
              <p className="gf-meta">John Walter • Oct 30, 2023</p>
            </div>
          </div>

          <div className="gf-post">
            <div className="gf-thumb"></div>
            <div>
              <p className="gf-post-title">Course title2</p>
              <p className="gf-meta">John Walter • Oct 30, 2023</p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="gf-col">
          <h3>Contact Us</h3>
          <p>gaming@gmaers.com</p>
          <p>+654 789 2435</p>
          <p>10 am to 8 pm</p>
        </div>

        {/* Buy Button */}
        <div className="gf-col">
          <h3>Buy Our Best Product</h3>
          <button className="gf-buy">Buy Now</button>
        </div>

      </div>

    </footer>
    <style>{`.gaming-footer {margin-top:50px;
  background: #1b1b1b;
  color: #eee;
  padding: 40px 0;
  width: 100%;
  font-family: "Poppins", sans-serif;
}

/* --- Top Section --- */
.gf-top {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 30px 10px;
}

.gf-col h3 {
  font-size: 20px;
  color: white;
  margin-bottom: 15px;
  font-weight: 600;
}

.gf-logo-col {
  text-align: center;
}

.gf-logo {
  background: rgba(144, 202, 249,1);
 
  padding: 20px 50px;
  font-size: 32px;
  font-weight: bold;
  color: white;
}

/* --- Divider --- */
.gf-divider {
  width: 90%;
  height: 1px;
  background: rgba(255,255,255,0.1);
  margin: 20px auto;
}

/* --- Middle Section --- */
.gf-mid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 20px 50px;
  gap: 30px;
}

/* Quick Links */
.gf-col ul {
  list-style: none;
  padding: 0;
}

.gf-col ul li {
  margin: 8px 0;
  cursor: pointer;
}

.gf-col ul li:hover {
  color: rgba(144, 202, 249,1);
}

/* Recent Posts */
.gf-post {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.gf-thumb {
  width: 50px;
  height: 50px;
  background: #555;
  border-radius: 5px;
}

.gf-post-title {
  font-weight: 600;
}

.gf-meta {
  font-size: 12px;
  color: #aaa;
}

/* Buy Button */
.gf-buy {
  background: rgba(144, 202, 249,1);
  border: none;
  padding: 12px 26px;
  color: white;
  border-radius: 50px;
  font-size: 18px;
  cursor: pointer;
  margin-top: 20px;
}

.gf-buy:hover {
  background: rgba(144, 202, 249,1);
}

/* Responsive */
@media (max-width: 900px) {
  .gf-mid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .gf-top {
    flex-direction: column;
    gap: 20px;
  }

  .gf-mid {
    grid-template-columns: 1fr;
  }

  .gf-logo {
    padding: 15px 30px;
  }
}
`}</style>
  </>);
}
